import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";
import IconLogoStyleFlag from "scmp-app/components/header/icon-logo-style-flag.svg";

export const Container = styled(ResponsiveContainer)``;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const StyledScmpStyleLogoFlag = styled(IconLogoStyleFlag)`
  inline-size: auto;
  block-size: 20px;

  ${theme.breakpoints.up("tablet")} {
    block-size: 25px;
  }
`;
